// = Types =
import { FC } from 'react';

// = Pages =
import Home from '@/pages/home/home';
import Catalog from '@/pages/catalog/catalog';
import AuthorPoll from '@/pages/poll/author-poll/author-poll';
import NewPoll from '@/pages/poll/new-poll/new-poll';
import ExecutorPoll from '@/pages/poll/executor-poll/executor-poll';
import ReportView from '@/pages/poll/report-view/report-view';
import { Page403 } from '@/pages/tech/403-page';
import ClearCookies from '@/pages/tech/ClearCookies';

interface RouteModel {
  path: string;
  key: string;
  component: FC;
  exact?: boolean;
}

const routes: RouteModel[] = [
  {
    path: '/',
    key: 'home',
    component: Home,
    exact: true,
  },
  {
    path: '/polls/',
    key: 'catalog-all',
    component: Catalog,
    exact: true,
  },
  {
    path: '/polls/:mode/:orgId/',
    key: 'catalog',
    component: Catalog,
    exact: true,
  },
  {
    path: '/poll/author/:id/',
    key: 'author',
    component: AuthorPoll,
    exact: true,
  },
  {
    path: '/poll/executor/:orgId/:pollId/',
    key: 'executor',
    component: ExecutorPoll,
    exact: true,
  },
  {
    path: '/poll/:pollId/report/:orgId/',
    key: 'report',
    component: ReportView,
    exact: true,
  },
  {
    path: '/polls/author/:orgId/new',
    key: 'new',
    component: NewPoll,
    exact: true,
  },
  {
    path: '/403',
    key: 'Page403',
    component: Page403,
    exact: true,
  },
  {
    path: '/clear',
    key: 'clear',
    component: ClearCookies,
    exact: true,
  },
];

export default routes;
